import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Layout/Header';
import Sidebar from './components/Layout/Sidebar';
import CourseGeneratorForm from './components/CourseGeneratorForm';
import History from './components/History';
import RatingForm from './components/RatingForm';
import AuthModal from './components/Auth/AuthModal';
import VerifyEmail from './components/VerifyEmail';
import ResetPassword from './components/ResetPassword';
import PricingPage from './components/Payment/PricingPage';
import PaymentSuccess from './components/Payment/PaymentSuccess';
import './App.css';

function App() {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleOpenAuth = () => {
    setShowAuthModal(true);
  };

  const handleCloseAuth = () => {
    setShowAuthModal(false);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
      <AuthProvider>
        <Router>
          <div className="app">
            <Header onOpenAuth={handleOpenAuth} onToggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
            
            <div className="app-body">
              <Sidebar onOpenAuth={handleOpenAuth} isOpen={sidebarOpen} onClose={closeSidebar} />
              
              <main className="main-content">
                <Routes>
                  <Route 
                    path="/" 
                    element={<CourseGeneratorForm onOpenAuth={handleOpenAuth} />} 
                  />
                  <Route path="/history" element={<History />} />
                  <Route path="/ratings" element={<RatingForm />} />
                  <Route path="/pricing" element={<PricingPage onOpenAuth={handleOpenAuth} />} />
                  <Route path="/payment/success" element={<PaymentSuccess />} />
                  <Route path="/verify-email" element={<VerifyEmail />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                </Routes>
              </main>
            </div>

            <AuthModal
              isOpen={showAuthModal}
              onClose={handleCloseAuth}
            />
          </div>
        </Router>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
